import { makeStyles } from '@mui/styles';

export const useCarouselCardStyles = makeStyles((theme) => ({
  cCard: {
    height: '300px',
    margin: '10px',
    transform: 'scale(0.8)',
    transition: 'transform 400ms linear !important',
    backgroundSize: 'cover',
    backgroundPosition: 'top',
  },

  cCActive: {
    transform: 'scale(1)',
  },
}));
